export enum ControleEstoqueSerieStatusFiltroEnum {
  Todos = 0,
  Disponivel = 1,
  Vendido = 2,
  EmReserva = 3,
}
